import {
  PATH_NAME_CONFERENCE_AUTH_FROM_CODE, PATH_NAME_CONFERENCE_LIVE_VIEW,
  PATH_NAME_CONFERENCE_MAIN
} from '@/common/resources/conference.router.const'
import {
  AUTHENTICATE_LIFE_TIME_MILLISECONDS,
  isExpireConferenceAuthentication,
  setAuthCookieForConference
} from '@/pages/conference/js/conference.utils'

// const AUTHENTICATE_LIFE_TIME_MILLISECONDS = 10800000
const authInfoCheck = (to, from, next) => {
  if (isExpireConferenceAuthentication()) {
    if (to.name === PATH_NAME_CONFERENCE_LIVE_VIEW) {
      next({ name: PATH_NAME_CONFERENCE_MAIN })
    } else {
      next()
    }
  } else { // 살아 있을때
    setAuthCookieForConference(AUTHENTICATE_LIFE_TIME_MILLISECONDS)
    if (to.name === PATH_NAME_CONFERENCE_MAIN || to.name === PATH_NAME_CONFERENCE_AUTH_FROM_CODE) {
      next({ name: PATH_NAME_CONFERENCE_LIVE_VIEW })
    } else {
      next()
    }
  }
}

export default [
  {
    path: '/conference',
    components: {
      conferenceLayout: () => import('@/pages/section/ConferenceLayout')
    },
    children: [
      {
        path: '',
        name: PATH_NAME_CONFERENCE_MAIN,
        alias: ['/', 'index', 'index.html'],
        components: {
          conferenceBody: () => import('@/pages/conference/ConferenceHomeView')
        },
        beforeEnter: authInfoCheck
      },
      {
        path: 'auth-from-code',
        name: PATH_NAME_CONFERENCE_AUTH_FROM_CODE,
        alias: 'auth-from-code.html',
        components: {
          conferenceBody: () => import('@/pages/conference/AuthFromCodeView')
        },
        beforeEnter: authInfoCheck
      },
      {
        path: 'live',
        name: PATH_NAME_CONFERENCE_LIVE_VIEW,
        alias: 'new.html',
        components: {
          conferencePlayer: () => import('@/pages/conference/ConferencePlayerLiveNew')
        },
        beforeEnter: authInfoCheck
      }
    ]
  }
]
